/**
 * Logger utility that disables console output in production
 *
 * Usage:
 *   import logger from './utils/logger';
 *   logger.log('Debug message');
 *   logger.error('Error message');
 */

const isProduction = process.env.NODE_ENV === 'production';

// Disable all console methods in production except errors
const logger = {
  log: isProduction ? () => {} : console.log.bind(console),
  debug: isProduction ? () => {} : console.debug.bind(console),
  info: isProduction ? () => {} : console.info.bind(console),
  warn: isProduction ? () => {} : console.warn.bind(console),
  error: console.error.bind(console), // Always keep errors
};

// Override global console in production to prevent any accidental logs
if (isProduction) {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  // Keep console.error for critical errors
}

export default logger;
